import React from "react";
import ReactGA from "react-ga";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Configuration, { translations } from "../../../config";

import Icon from "../../../components/Icon";
import { registrateUser } from "../../../actions/Users";
import { message } from "../../../actions";
import AGB from "../../../containers/pages/Agb";
import DataProtection from "../../../containers/pages/DataProtection";
import Modal from "../../../components/Modal";

const mapStateToProps = ( state ) =>
{
	return {};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		registrateUser: ( formData ) =>
		{
			return dispatch( registrateUser( formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class SummaryFields extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = this.props.fieldValues.summary
			? this.props.fieldValues.summary
			: {
				...this.props.state,
				agb_approval: false,
				data_protection_approval: false,
				billing_info: ""
			};
		
		this.agbApproval = React.createRef();
		this.dataProtectionApproval = React.createRef();
		this.dataProtectionApprovalModal = React.createRef();
		
		this.handleInformation = this.handleInformation.bind( this );
		this.handleConditions = this.handleConditions.bind( this );
		this.handleCancel = this.handleCancel.bind( this );
		this.handleRegistrateUser = this.handleRegistrateUser.bind( this );
	}
	
	componentDidMount()
	{
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
	} // function componentDidMount()
	
	handleInformation( a_event )
	{
		this.setState( { billing_info: a_event.target.value } );
		
	} // function handleInformation(...)
	
	handleConditions( a_event, a_value = !this.state.agb_approval )
	{
		this.setState( { agb_approval: a_value } );
		
	} // function handleConditions(...)
	
	handleDataProtection( a_event, a_value = !this.state.data_protection_approval )
	{
		this.setState( { data_protection_approval: a_value } );
		
	} // function handleDataProtection(...)
	
	handleCancel( a_event )
	{
		a_event.preventDefault();
		
		// Die AGB und Datenschutzbestimmungen müssen immer erneut akzeptiert werden
		// Die persönliche Nachricht merken
		this.props.saveValues( {
			// agb_approval: this.state.agb_approval,
			// data_protection_approval: this.state.data_protection_approval,
			billing_info: this.state.billing_info
		}, "summary" );
		
		this.props.previousStep();
		
	} // function handleCancel(...)
	
	handleRegistrateUser( a_event )
	{
		a_event.preventDefault();
		
		this.isValid = true;
		
		if ( !this.state.data_protection_approval )
		{
			this.dataProtectionApproval.current.className = "validation-failed";
			this.dataProtectionApproval.current.focus();
			this.props.message( "Bitte akzeptieren Sie unsere Datenschutzbedingungen.", "warning", 5000 );
			this.isValid = false;
		}
		else
		{
			this.dataProtectionApproval.current.className = this.dataProtectionApproval.current.className.replace( "validation-failed", "" );
		}
		
		if ( !this.state.agb_approval )
		{
			this.agbApproval.current.className = "validation-failed";
			this.agbApproval.current.focus();
			this.props.message( "Bitte akzeptieren Sie unsere AGB.", "warning", 5000 );
			this.isValid = false;
		}
		else
		{
			this.agbApproval.current.className = this.agbApproval.current.className.replace( "validation-failed", "" );
		}
		
		if ( !this.isValid )
		{
			return false;
		}
		
		// Informationen zwischenspeichern falls etwas fehlschlägt
		if ( !this.props.fieldValues.hasOwnProperty( "summary" ) )
		{
			this.props.saveValues( {
				agb_approval: this.state.agb_approval,
				data_protection_approval: this.state.data_protection_approval,
				billing_info: this.state.billing_info
			}, "summary" );
		}
		
		// Zusammenfassungsdaten anhängen
		const formData = Object.assign(
			{},
			this.props.fieldValues,
			{
				summary: {
					agb_approval: this.state.agb_approval,
					data_protection_approval: this.state.data_protection_approval,
					billing_info: this.state.billing_info
				}
			}
		);
		
		this.props.registrateUser( formData ).then(
			a_result =>
			{
				if ( a_result > 0 )
				{
					this.setState( { order_id: a_result } );
				}
			}
		);
		
	} // function handleRegistrateUser(...)
	
	render()
	{
		const { customer, article, payment } = { ...this.props.fieldValues };
		
		return <React.Fragment>
			{
				this.state.order_id > 0 &&
				<div className={"col s12 tCenter primary-color white-text boxShadowRight"}>
					<h6>Ihre Bestellung war erfolgreich</h6>
					<h3>Vielen Dank für Ihre Bestellung</h3>
					<p>Ihre Bestellnummer lautet<br/><strong>{this.state.order_id}</strong></p>
					<p>In Kürze erhalten Sie von uns Ihre detaillierte Bestellbestätigung per E-Mail und einen Aktivierungslink für Ihren persönlichen Zugang.</p>
					<div className={"col s12 spacer cleared"}/>
				</div>
			}
			<div className={"col s12 relative summary"}>
				<div className={"col s12 m6 l7 xl8 unset-padding"}>
					<div className={"col s12"}>
						<h6>Rechnungsanschrift</h6>
					</div>
					<div className={"col s12 spacer"}/>
					<div className={"col s12 secondary-color-text"}>
						{customer.organization_name}<br/>
						{customer.sex === "m" ? "Herr" : customer.sex === "w" ? "Frau" : ""} {customer.forename} {customer.surname}<br/>
						{customer.organization_street} {customer.organization_street_number}<br/>
						{customer.organization_postal_code} {customer.organization_city}
						<p><strong>E-Mail:</strong> {customer.email}</p>
					</div>
				</div>
				
				<div className={"col s12 m6 l5 xl4 light-grey right-block unset-radius dashed-block-outer"}>
					<div className={"relative"}>
						<div className={"col s12 dashed-block padding-top"}>
							<div className={"col s6 price"}>
								<div className={"padding-top"}>
									<label className={"primary-color-text"}>Anzahl Domains</label>
								</div>
								<span className={"value sub"}>{article.domains.length}</span>
								<span className={"additional"}>X</span>
							</div>
							<div className={"col s6 price tRight"}>
								<div className={"padding-top"}>
									<label className={"primary-color-text"}>Preis pro Domain</label>
								</div>
								<span className={"value sub"}>
							 {( parseFloat( article.price ) ).toLocaleString( Configuration.location, Configuration.priceString )}
							 </span>
								<span className={"additional"}>Euro</span>
							</div>
							<div className={"col s12 summaryFields"}>
								<div className={"primary-color-text unset-padding oneLine margin-bottom"}/>
								<div className={"cleared"}/>
								<div className={"netField price"}>
									<label className={"col s4 unset-padding primary-color-text margin-top"}>Netto</label>
									<div className={"col s8 unset-padding tRight"}>
									<span className={"value"}>
									 {( parseFloat( article.summary_price ) ).toLocaleString( Configuration.location, Configuration.priceString )}
									 </span>
										<span className={"additional"}>Euro</span>
									</div>
								</div>
								<div className={"taxField price"}>
									<label className={"col s4 unset-padding primary-color-text margin-top"}>zzgl. 19% USt.</label>
									<div className={"col s8 unset-padding  tRight"}>
									<span className={"value"}>
									 {( parseFloat( article.summary_price ) * 0.19 ).toLocaleString( Configuration.location, Configuration.priceString )}
									 </span>
										<span className={"additional"}>Euro</span>
									</div>
								</div>
								<div className={"cleared"}/>
								<div className={"primary-color-text unset-padding summaryLine margin-top"}/>
								<div className={"grossField price"}>
									<label className={"col s4 unset-padding primary-color-text margin-top"}>Brutto</label>
									<div className={"col s8 unset-padding tRight"}>
									<span className={"value"}>
									 {( parseFloat( article.summary_price ) * 1.19 ).toLocaleString( Configuration.location, Configuration.priceString )}
									 </span>
										<span className={"additional"}>Euro</span>
									</div>
								</div>
								<div className={"price tRight"}>
									<span className={"additional"}>pro Monat</span>
								</div>
							</div>
							<div className={"cleared spacer"}/>
							
							<div className={"col s12 price"}>
								<div className={"col s12 unset-padding"}>
									<span className={"col xl8 unset-padding-left primary-color-text"}>Mindestlaufzeit</span>
									<span className={"col xl4 unset-padding-right tRight"}>{article.contract_duration} {article.contract_duration > 1 ? "Monate" : "Monat"}</span>
								</div>
								<div className={"cleared spacer"}/>
								<div className={"col s12 unset-padding margin-bottom primary-color-text"}>Bankeinzugskonto</div>
								<div className={"col s12 unset-padding"}>
									<span className={"col xl4 unset-padding-left light"}>Kontoinhaber:</span>
									<span className={"col xl8 unset-padding-right tRight"}>{payment.account_owner}</span>
								</div>
								<div className={"col s12 unset-padding"}>
									<span className={"col xl2 unset-padding-left light"}>IBAN:</span>
									<span className={"col xl10 unset-padding-right tRight"}>{payment.iban}</span>
								</div>
								<div className={"col s12 unset-padding"}>
									<span className={"col xl2 unset-padding-left light"}>BIC:</span>
									<span className={"col xl10 unset-padding-right tRight"}>{payment.credit_institution}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={"col s12 spacer"}/>
				
				<div className={"col s12 l6 xl8 unset-padding form"}>
					<div className={"col s12 xl8"}>
						<label>
							<div className={"form-element-name"}>Ihre persönliche Nachricht an uns</div>
						</label>
						<div className={"col s12 billingInfo light-grey"}>
							<textarea name={"billing_info"} title={"Bearbeitungsinformationen"} maxLength={"255"}
							          defaultValue={this.state.billing_info}
							          onBlur={( a_event ) => this.handleInformation( a_event )}
							          disabled={this.state.order_id > 0 ? "disabled" : ""}/>
						</div>
					</div>
					<div className={"col s12 spacer cleared"}/>
					
					<div className={`col s12 ${this.state.agb_approval ? "checkedLabel" : "checkableLabel"}`}>
						<label>
							<input ref={this.agbApproval}
							       name={"agb_approval"}
							       title={"Die AGB akzeptieren"}
							       type={"checkbox"}
							       onChange={( a_event ) => this.handleConditions( a_event )}
							       checked={this.state.agb_approval} disabled={this.state.order_id > 0 ? "disabled" : ""}/>
							<span>Die </span>
						</label> <Modal title={<h1 className={"primary-color-text margin-top margin-bottom padding-top"}>Allgemeine Geschäftsbedingungen der Test GmbH</h1>}
						                trigger={<span className={"a"}>AGB</span>}
						                footer={<button onClick={( a_event ) => this.handleConditions( a_event, true )}
						                                data-modal={"confirm"}>Ich stimme zu</button>}>
						<AGB inline/>
					</Modal> <span className={"afterInputLabel"}
						           onClick={( a_event ) => this.handleConditions( a_event )}>von {translations.de_DE.words.appName} gelesen und akzeptiert.</span>
						<span className="form-element-required">*</span>
					</div>
					
					<div className={`col s12 ${this.state.data_protection_approval ? "checkedLabel" : "checkableLabel"}`}>
						<label>
							<input ref={this.dataProtectionApproval}
							       name={"data_protection_approval"}
							       title={"Die Datenschutzbedingungen akzeptieren"}
							       type={"checkbox"}
							       onChange={( a_event ) => this.handleDataProtection( a_event )}
							       checked={this.state.data_protection_approval} disabled={this.state.order_id > 0 ? "disabled" : ""}/>
							<span>Die </span>
						</label> <Modal title={<h1 className={"primary-color-text margin-top margin-bottom padding-top"}>Datenschutzerklärung</h1>}
						                trigger={<span className={"a"}>Datenschutzerklärung</span>}
						                footer={<button onClick={( a_event ) => this.handleDataProtection( a_event, true )}
						                                data-modal={"confirm"}>Ich stimme zu</button>}>
						<DataProtection inline/>
					</Modal> <span className={"afterInputLabel"}
						           onClick={( a_event ) => this.handleDataProtection( a_event )}>von {translations.de_DE.words.appName} gelesen und akzeptiert.</span>
						<span className="form-element-required">*</span>
					</div>
					<div className={"col s12 spacer"}/>
					{
						this.state.order_id > 0
							? <div className="col s12">
								<NavLink className={"btn secondary-color"} to={"/"}>
									<Icon size={14} iconName={"leave"}/><span>Zurück zur Startseite</span>
								</NavLink>
							</div>
							: <div className="col s12">
								<button className={"secondary-color"} onClick={( a_event ) => this.handleCancel( a_event )}>
									<Icon size={14} iconName={"leave"}/><span>Zurück zur Zahlung</span>
								</button>
								<button onClick={( a_event ) => this.handleRegistrateUser( a_event )}>
									<Icon size={14} iconName={"next"}/><span>Registrieren und kostenpflichtig bestellen</span>
								</button>
							</div>
					}
				</div>
			</div>
		</React.Fragment>;
		
	} // function render()
	
} // class

SummaryFields = connect(
	mapStateToProps,
	mapDispatchToProps
)( SummaryFields );

export default SummaryFields;
